import * as styles from "@/styles/modules/LineRule.module.scss"

const LineRule = ({
  className,
  label,
}: {
  className?: string
  label?: string
}) => {
  return (
    <div className={[styles.wrapper, className].join(" ")}>
      <div className={styles.segment} />
      {label && (
        <>
          <h4 className={`${styles.label} eyebrow`}>{label}</h4>
          <div className={styles.segment} />
        </>
      )}
    </div>
  )
}

export default LineRule
